import supabaseClient from '@/api/supabaseClient.ts';
import { SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { VerifyEmailRequest } from '@/types/request/VerifyEmailRequest';

const useVerifyEmail = () => {
  const client = supabaseClient;

  const mutationFn = async (request: VerifyEmailRequest) => {
    return verifyEmail(client, request);
  };

  return useMutation({
    mutationFn,
  });
};

export default useVerifyEmail;

async function verifyEmail(client: SupabaseClient, request: VerifyEmailRequest): Promise<void> {
  const { error } = await client.auth.verifyOtp({ email: request.email, token: request.code, type: 'email' });

  if (error) throw new Error(error.message);
}
